/** The site's languages (the app's own, src/shared/language.ts) and how a visitor's is chosen. No copy here: the
 * router imports this file, so the six languages' texts stay in the site's own chunk. */
export const SITE_LANGS = ["fr", "en", "es", "de", "it", "pt"] as const;
export type SiteLang = (typeof SITE_LANGS)[number];

export function isSiteLang(value: unknown): value is SiteLang {
  return typeof value === "string" && (SITE_LANGS as readonly string[]).includes(value);
}

/** The visitor's language: the one asked for in the address, else the browser's first known one, else French. */
export function pickSiteLang(asked: unknown, preferred: readonly string[] = typeof navigator === "undefined" ? [] : navigator.languages): SiteLang {
  if (isSiteLang(asked)) return asked;
  for (const tag of preferred) {
    const base = tag.toLowerCase().split("-")[0];
    if (isSiteLang(base)) return base;
  }
  return "fr";
}
